module.exports = __webpack_public_path__ + "amcharts/images/dragIconRoundSmall.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRoundSmall.svg
// module id = 255
// module chunks = 0